import '../yet-another-abortcontroller-polyfill';
import 'whatwg-fetch';
import * as Browser from './Browser';
import * as UnifyHeight from './UnifyHeight';

const defaultSetting = {
    method: 'GET',
    body: undefined,
    signal: undefined,
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    }
};

function drawSnippets(snippets) {
    Object.keys(snippets).map(function(snippetId) {
        let snippet = document.getElementById(snippetId);
        snippet.innerHTML = snippets[snippetId];
        loadsripts(snippet);
    });
}

function loadsripts(snippet) {
    let scripts = snippet.querySelectorAll('script');
    scripts.forEach(function(script, key) {
        let scriptEl = document.createElement('script');
        scriptEl.innerHTML = script.innerHTML;

        if (script.hasAttributes()) {
            const attrs = script.attributes;
            for (let j = 0; j < attrs.length; j++) {
                const attrName = attrs[j].name;
                scriptEl[attrName] = attrs[j].value;
            }
        }

        document.head.appendChild(scriptEl);
        scripts[key].parentNode.removeChild(scripts[key]);
    });
}

function processSnippets(response) {
    if(response.hasOwnProperty('snippets')) {
        drawSnippets(response.snippets);
        UnifyHeight.applyTo('.js-unify-height');
        UnifyHeight.applyDataAttribute();
    }

    return response;
}

function processUrlChange(response)  {
    if(response.hasOwnProperty('newUrl')) {
        Browser.changeUrl(response.newUrl);
    }

    return response;
}

function processRedirection(response) {
    if(response.hasOwnProperty('redirect')) {
        Browser.redirect(response.redirect);
    }

    return response;
}

function prepareFetchSettings(settings) {
    return {
        credentials: 'include',
        method: settings.method.toUpperCase(),
        body: settings.body,
        headers: new Headers(settings.headers),
        signal: settings.signal,
    }
}

export function sendRequest(requestSettings = {})
{
    const settings = Object.assign({}, defaultSetting, requestSettings);

    return fetch(
        requestSettings.url, prepareFetchSettings(settings)
    ).then(response => { // vytahne z odezvy JSON a preda dal
        console.log('test1');
        return response.json();
    }).then(response => {// Ověříme jestli response vratila snippety a připadně je překreslíme
        console.log('test2', response);
        return processSnippets(response);
    }).then(response => {// Ověříme jestli response neposlala pokyn k aktualizaci adresy browseru
        console.log('test3', response);
        return processUrlChange(response);
    }).then(response => { // Ověříme jestli nepřišel pokyn k přesměrování
        console.log('test4', response);
        return processRedirection(response);
    }).then(response => {
        console.log('test5', response);
        return Object.assign({}, requestSettings, {response: response});
    }).catch(function(error) {
        console.log(error);
    });
}
